import { useLocale } from "~/lib/i18n/hooks/useLocale"
import { getI18nKey } from "~/lib/i18n/utils/get-i18n"

function useMarket() {
  const locale = useLocale()
  return getI18nKey(locale, "market")
}

export default useMarket
